<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" xs="12" md="2">
        <v-text-field outlined dense filled readonly label="Job No" v-model="JobNo"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="4">
        <v-text-field outlined dense label="Customer Name" v-model="record.CustomerName"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-text-field outlined dense label="Phone" v-model="record.CustomerPhone"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-text-field outlined dense label="Email" v-model="record.CustomerEmail"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="6">
        <v-autocomplete
          autocomplete="off"
          dense
          outlined
          v-model="record.ProductId"
          :items="products"
          label="ItemName"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <DatePicker @date="setDate" :myDate="date" :title="`Date Returned`"></DatePicker>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-autocomplete
          autocomplete="off"
          dense
          outlined
          v-model="record.ReceivedBy"
          :items="users"
          label="Received By"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" md="12">
        <v-textarea outlined rows="2" label="Problem Details" v-model="record.ProblemDetails"></v-textarea>
      </v-col>

      <v-col cols="12">
        <v-btn v-if="docCreate == true" color="accent" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="accent" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    JobNo: null,
    users: [],
    products: [],
    loader: false,
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.ReturnDate = date;
    },
    sendData() {
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProducts() {
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/products`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/26`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.JobNo = res.ResponseData.NextNumber;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getUsers();
    this.getProducts();
    this.getDocNum();
  },
};
</script>